import * as React from 'react';
import Button from '@material-ui/core/Button';

function PremiumPastDue({profile} :any) {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p>On trial Premium Plan subscription. Your trial subscription expires on {profile.subscription?.trial_ends_at}</p>
      </p>
    </div>
  );
}

export default PremiumPastDue;
